var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{class:{
    'p-gallery__exhibitBlock': true,
    'img-hover-background': _vm.hover,
  },style:({
    width: _vm.width,
    height: _vm.height,
    maxHeight: _vm.height,
    maxWidth: _vm.width,
    paddingBottom: _vm.paddingBottom,
  }),attrs:{"src":_vm.src}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }